import script from "./EditColumnsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./EditColumnsDialog.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__